import PropTypes from 'prop-types'
import { Component } from 'react'
import { Link } from '../../i18n'
import { Preview } from './styles'

class ArtistRoundPreview extends Component {
  static propTypes = {
    artist: PropTypes.instanceOf(Object).isRequired,
    previewGap: PropTypes.number.isRequired,
    previewGapPhone: PropTypes.number.isRequired
  };

  render() {
    const { artist, previewGap, previewGapPhone } = this.props

    return (
      <Link
        key={artist.id}
        href={`/artist?id=${artist.id}`}
        as={`/artist/${artist.id}/${artist.slug || ''}`}
        passHref
      >
        <Preview previewGap={previewGap} previewGapPhone={previewGapPhone}>
          <div className="photo-wrapper">
            <img className="photo" src={artist.photo || '/static/images/empty-artist.svg'} alt={artist.name} />
          </div>
          <p className="name">{artist.name}</p>
        </Preview>
      </Link>
    )
  }
}

export default ArtistRoundPreview
